import { CHDataActionPayload, CHSuccessActionResult } from "@app/root-store/actions";
import { Action } from "@ngrx/store";
import { CHDataAction, CHDataSuccessAction, DataErrorAction } from "../../../shared/resources/data-actions";
import { DataServiceError } from "../../../shared/services/data-service-error";
import { CHDeviceMetadata } from "../clarehome.state";

export enum ActionTypes {
    ClearDeviceMetadata = "[Project Management] ClearDeviceMetadata",
    GetDeviceMetadata = "[Project Management] GetDeviceMetadata",
    GetDeviceMetadataSuccess = "[Project Management] GetDeviceMetadataSuccess",
    GetDeviceMetadataFailure = "[Project Management] GetDeviceMetadataFailure",
}

export type DeviceMetadataResultPayload = CHSuccessActionResult<CHDeviceMetadata>;
type DeviceMetadataPayload = CHDataActionPayload;
type DeviceMetadataAction = CHDataAction<CHDeviceMetadata>;
type DeviceMetadataSuccessAction = CHDataSuccessAction<CHDeviceMetadata>;
type DeviceMetadataFailureAction = DataErrorAction<DeviceMetadataResultPayload>;
type DeviceMetadataError = DataServiceError<DeviceMetadataResultPayload>;

export class ClearDeviceMetadata implements Action {
    readonly type = ActionTypes.ClearDeviceMetadata;
}

export class GetDeviceMetadata implements DeviceMetadataAction {
    readonly type = ActionTypes.GetDeviceMetadata;
    constructor(public readonly payload: DeviceMetadataPayload) {}
}

export class GetDeviceMetadataSuccess implements DeviceMetadataSuccessAction {
    readonly type = ActionTypes.GetDeviceMetadataSuccess;
    constructor(public readonly result: DeviceMetadataResultPayload) {}
}

export class GetDeviceMetadataFailure implements DeviceMetadataFailureAction {
    readonly type = ActionTypes.GetDeviceMetadataFailure;
    constructor(public readonly error: DeviceMetadataError) {}
}

export type Actions = ClearDeviceMetadata | GetDeviceMetadata | GetDeviceMetadataSuccess | GetDeviceMetadataFailure;
